import React, { useEffect, useRef, useState } from 'react';
import '../../../assets/css/subscription.css';
import CheckBroken from '../../../assets/img/check-circle-broken.svg';
import { Link } from 'react-router-dom';
import Header from 'components/Header';

const SubSuccess = () => {
  return (
    <div className="wrapper">
        <Header />
      <div className="main-content">
        <section className="subscription-sec">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="blankList-box-cover">
                  <div className="blankList-box">
                    <img className="akarFile" src={CheckBroken} />
                    <h2>Thanks for Subscribing! 🎉 </h2>
                    <p>
                      We’re thrilled to have you with us. Your subscription is now active, and your journey toward a
                      happier ending begins now.
                    </p>
                    <Link to="/projects" className="btn-black">
                      Go to Dashboard
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SubSuccess;
